(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define(["d3"], factory);
	else if(typeof exports === 'object')
		exports["Koto"] = factory(require("d3"));
	else
		root["Koto"] = factory(root["d3"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_83__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/